module.exports = __webpack_public_path__ + "img/recognition.714e43b0.svg";